import {deserializeNotification} from 'lib/api/records'
import {Map} from 'immutable'
import {pending, fulfilled, rejected} from 'lib/promiseMiddlewareHelpers'
import {buildQueryString, getCurrentUser} from 'lib/utils'
import fetchJSON from 'lib/fetchJSON'

// Actions
export const LOAD_NOTIFICATIONS = 'notifications/LOAD_NOTIFICATIONS'
export const MARK_SEEN = 'notifications/MARK_SEEN'
export const CTA_CLICKED = 'notifications/CTA_CLICKED'

const preloadList = getCurrentUser().notifications || []

// A helper for parsing the preload and ajax results
const notificationsListToMap = (results) => {
  const notifications = results || []
  return Map(notifications.map(n => [n.id, deserializeNotification(n)]))
}

const initialState = Map({
  notifications: notificationsListToMap(preloadList), // id -> notification
  loading: false,
  resultsCount: 0,
  actionsTaken: Map()
})

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case fulfilled(LOAD_NOTIFICATIONS): {
      const {page} = action.meta
      const {results, results_count: resultsCount} = action.payload
      const newNotifications = notificationsListToMap(results)

      const notifications = state.get('notifications').mergeDeep(newNotifications)

      const nextPage = resultsCount > notifications.size ? page + 1 : -1

      return state.mergeDeep({
        notifications,
        nextPage,
        resultsCount,
        loading: false
      })
    }
    case rejected(LOAD_NOTIFICATIONS): {
      // TODO: do something with the error stuff?
      return state.merge({loading: false})
    }
    case pending(LOAD_NOTIFICATIONS): {
      return state.merge({loading: true})
    }
    case pending(MARK_SEEN): {
      return state
    }
    case fulfilled(MARK_SEEN):
    case rejected(MARK_SEEN): {
      return state
    }
    case pending(CTA_CLICKED): {
      const actionsTaken = state.get('actionsTaken').set(action.meta.id, action.meta)
      return state.merge({actionsTaken: actionsTaken})
    }
    case rejected(CTA_CLICKED): {
      const errorMeta = {
        error: true,
        errorText: action.payload.error,
        time: action.meta.time
      }
      const actionsTaken = state.get('actionsTaken').set(action.meta.id, errorMeta)
      return state.merge({actionsTaken: actionsTaken})
    }
    case fulfilled(CTA_CLICKED): {
      // Clicking a on a CTA won't clear the notification from the list, but it will leave the it in 'actionsTaken'.  This way the user will see the result of them clicking, until they refresh the page.
      return state
    }
    default:
      return state
  }
}

const PER_PAGE = 20

// Action Creators

export const loadNotifications = (page = 0) => {
  const query = buildQueryString({limit: PER_PAGE, offset: page * PER_PAGE})
  return {
    type: LOAD_NOTIFICATIONS,
    payload: fetchJSON(`/notifications.json?${query}`),
    meta: {page}
  }
}

export const markNotificationsSeen = (notificationIds) => ({
  type: MARK_SEEN,
  payload: fetchJSON(`/notifications/mark_seen`, {seen_ids: notificationIds})
})

export const ctaClicked = (endpoint, payload = {}, meta) => {
  return {
    type: CTA_CLICKED,
    payload: fetchJSON(endpoint, payload, {method: 'POST'}),
    meta: meta
  }
}
